// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/skeleton/style/index.less
// module id = 1125
// module chunks = 1